import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Loader } from "@itandi/itandi-bb-ui/Loader";
import Link from "next/link";
import type { FC } from "react";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { AccountSetting } from "~/components/specifics/vendors/settings/accounts/AccountSetting";
import { useSessions } from "~/hooks/vendors/useSessions";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

export const Page: FC = () => {
	const { data: session } = useSessions().index();

	if (session === null) {
		return <Loader />;
	}

	return (
		<VendorSettingLayout>
			<div className={SettingStyles.SpBreadcrumbsWrapper}>
				<Breadcrumbs
					items={[
						{ as: Link, href: PATH, label: "設定一覧" },
						{ label: "アカウント詳細" }
					]}
				/>
			</div>
			<AccountSetting session={session} />
		</VendorSettingLayout>
	);
};
